import React from 'react'
import Resourcemanagement from '../Component/Resource/Resourcemanagement'

const Resource = () => {
  return (
    <div><Resourcemanagement/></div>
  )
}

export default Resource